import { render, staticRenderFns } from "./UpdateCurrency.vue?vue&type=template&id=1aa4cbd0&scoped=true"
import script from "./UpdateCurrency.vue?vue&type=script&lang=js"
export * from "./UpdateCurrency.vue?vue&type=script&lang=js"
import style0 from "./UpdateCurrency.vue?vue&type=style&index=0&id=1aa4cbd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa4cbd0",
  null
  
)

export default component.exports